import { getCurrentWorkspaceId } from '@utils/store';
import { http } from './base-http';

export const startDebugTunnelApi = (
  pipelineId: string,
  workspaceId: string = getCurrentWorkspaceId(),
) => {
  return http.post(`/api/v2/workspaces/${workspaceId}/pipelines/${pipelineId}/debug-tunnel`);
};
